/**
 * Parse a Supabase edge function error into a plain object with an `error` field.
 *
 * Supabase's `FunctionsHttpError.context` is the raw `Response` object, whose body
 * is a `ReadableStream` that must be read asynchronously. We clone before reading
 * so callers can still access the original response if needed.
 */
export async function parseEdgeFunctionError(
  error: unknown,
): Promise<Record<string, unknown>> {
  const err = error as { context?: Response; message?: string } | null;
  const response = err?.context;

  if (response && typeof response.clone === "function") {
    try {
      return await response.clone().json();
    } catch {
      try {
        const text = await response.clone().text();
        if (text) return { error: text };
      } catch {
        /* fall through to message fallback */
      }
    }
  }

  return { error: err?.message || "Unknown error" };
}
